import { WindowProperty, getWindowValue } from "../../utils/window.utils";

export const getClientId = (): string =>
    getWindowValue(`${WindowProperty.IHUB_STATE}.tadaContext.clientId`);

export const getCustomerId = (): string =>
    getWindowValue(`${WindowProperty.IHUB_STATE}.tadaContext.customerId`);
